import React, { useState } from "react"
import "./FloatingBanner.scss"
import NuvoImage from "./NuvoImage"
import Button from "./Button/Button"

const FloatingBanner = () => {
  const [isOpen, setIsOpen] = useState(true)
  if (!isOpen) return null
  return (
    <div className="floating-banner">
      <div className="floating-banner-card">
        <div className="floating-banner-close">
          <button
            className="floating-banner-close-button"
            onClick={() => setIsOpen(false)}
            aria-label="Close banner">
            &times;
          </button>
        </div>
        <div className="floating-banner-grid">
          <div className="floating-banner-image">
            <NuvoImage
              useAR={false}
              width="500"
              responsive
              cloudname="nuvolum"
              publicId="NALO/DEV/doctor-geren-pop-up"
            />
          </div>
          <div className="floating-banner-text">
            <p>NOW INTRODUCING</p>
            <p className="bold">DR. VICTORIA GEREN!</p>
            <Button
              href="/victoria-geren-dds-ms/"
              destination="internal"
              className="contained"
              buttonText="Get to know Dr. Geren"
            />
          </div>
        </div>

        <svg
          className="floating-banner-svg left"
          width="190"
          height="202"
          viewBox="0 0 190 202"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M326.557 0.000204421L329.386 2.82863L2.82843 329.386L0 326.558L326.557 0.000204421Z"
            fill="#006EB9"
          />
          <path
            d="M331.507 4.94942L334.335 7.77785L7.77765 334.335L4.94922 331.507L331.507 4.94942Z"
            fill="#0087CD"
          />
          <path
            d="M336.458 9.89962L339.286 12.728L12.7288 339.285L9.90039 336.457L336.458 9.89962Z"
            fill="#00AEEF"
          />
          <path
            d="M341.407 14.8498L344.235 17.6782L17.678 344.236L14.8496 341.407L341.407 14.8498Z"
            fill="#00BAC8"
          />
          <path
            d="M346.356 19.799L349.185 22.6275L22.6273 349.185L19.7988 346.356L346.356 19.799Z"
            fill="#00B8A8"
          />
          <path
            d="M351.305 24.7492L354.134 27.5777L27.5765 354.135L24.748 351.307L351.305 24.7492Z"
            fill="#5AC098"
          />
        </svg>
        <svg
          className="floating-banner-svg right"
          width="190"
          height="202"
          viewBox="0 0 190 202"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M326.557 0.000204421L329.386 2.82863L2.82843 329.386L0 326.558L326.557 0.000204421Z"
            fill="#006EB9"
          />
          <path
            d="M331.507 4.94942L334.335 7.77785L7.77765 334.335L4.94922 331.507L331.507 4.94942Z"
            fill="#0087CD"
          />
          <path
            d="M336.458 9.89962L339.286 12.728L12.7288 339.285L9.90039 336.457L336.458 9.89962Z"
            fill="#00AEEF"
          />
          <path
            d="M341.407 14.8498L344.235 17.6782L17.678 344.236L14.8496 341.407L341.407 14.8498Z"
            fill="#00BAC8"
          />
          <path
            d="M346.356 19.799L349.185 22.6275L22.6273 349.185L19.7988 346.356L346.356 19.799Z"
            fill="#00B8A8"
          />
          <path
            d="M351.305 24.7492L354.134 27.5777L27.5765 354.135L24.748 351.307L351.305 24.7492Z"
            fill="#5AC098"
          />
        </svg>
      </div>
    </div>
  )
}

export default FloatingBanner
